// extracted by mini-css-extract-plugin
module.exports = {"switchAddCertificateMethod":"AddCertificateModal_switchAddCertificateMethod__1ot3B"};